// extracted by mini-css-extract-plugin
export default {"dot":"CustomCursor_dot__oBpqp","ring":"CustomCursor_ring__siO4u","hover":"CustomCursor_hover__OI0XN"};